import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classes from './index.scss';

class PasswordStrengthMeter extends Component {

  static defaultProps = {
    passwordScore: 0,
  }

  render() {
    const { passwordScore, inputValid } = this.props;
    const meterStrength = () => {
      if (passwordScore === -1) return '';
      if (passwordScore < 2) {
        return classes.weak;
      } else if (passwordScore < 4) {
        return classes.fair;
      } else {
        return classes.good;
      }
    };
    const shiftMeter = () => {
      if (inputValid === false) return classes.shiftMeter;
    };

    return (
      <div className={`${classes.passwordStrengthMeter} ${shiftMeter()}`}>
        <div className={classes.meter}>
          <div className={`${classes.passwordStrength} ${meterStrength()}`} />
        </div>
      </div>
    );
  }
}

PasswordStrengthMeter.propTypes = {
  passwordScore: PropTypes.number.isRequired,
  inputValid: PropTypes.bool
};

export default PasswordStrengthMeter;
